module.exports = __webpack_public_path__ + "img/user-check.ec09f6f4.svg";